// const LAMBDA_API = "http://localhost:3000" 
const LAMBDA_API = "https://pi1x7i8m15.execute-api.ap-northeast-1.amazonaws.com/prod"
const LAMBDA_API2 = "https://m80y15n053.execute-api.ap-northeast-1.amazonaws.com/prod"
const CDN_URL = "https://cdn.jsrm.or.jp"
const ZIP_API = "https://madefor.github.io/postal-code-api/api/v1"

export const AUTHORIZATION = "8086fc15-53e0-4165-b297-6935549101b4"
// export const AUTHORIZATION = "allow"

// export const SITE_TITLE = "生殖医療専門医ポイント確認"
export const SITE_TITLE = "WEB会員証"
export const PARTICIPATION_FEE = 20

export const QR_CODE_URL = `${LAMBDA_API2}/qrcode/`

export const API = {
	'login': `${LAMBDA_API2}/login`,
	'pdfEvents': `${LAMBDA_API2}/init`,
	'forgot': `${LAMBDA_API2}/forgot`,
	'password': `${LAMBDA_API2}/member/password`,
	'photo': `${LAMBDA_API}/photo`,
	'photoList': (id: string) => `${LAMBDA_API}/photo/${id}`,
	'messageAll': `${LAMBDA_API}/log/message/0`,
	'message': (id: number) => `${LAMBDA_API}/log/message/${id}`,
  'init': (id: string) => `${LAMBDA_API}/member/init/${id}`,
  "reciptDownload": (id: string, date: string) => `${LAMBDA_API2}/receipt/annual/${id}/${date}`,
  zipLookup: (zip1: string, zip2: string) => `${ZIP_API}/${zip1}/${zip2}.json`,
  "modify": `${LAMBDA_API2}/member/modify`,
  "mail": `${LAMBDA_API2}/member/mail`,
  "oldLogin": "https://member.jsrm.or.jp/api/1.0/login"
}

export const COPYRIGHT = 'Copyright © (一社)日本生殖医学会 All rights reserved.'
export const JSRM_BUTTON = {
	desc: '日本生殖医学会へ戻る',
	href: 'http://www.jsrm.or.jp'
}

export const PAGE = {
	Loading: {
		id: "loading"
	},
	Login: {
		id: "loginPage"
	},
	Policy: {
		id: "policyPage"
	},
	Top: {
		id: "topPage"
	},
	Forgot: {
		id: "forgotPage"
	},
	Password: {
		id: "passwordPage"
	},
	Profile: {
		id: "profile"
	},
}

export const STATE_KEY = {
	Event: 'event',
	User: 'user',
	LoginForm: 'loginForm',
	CreditForm: 'creditForm',
	Fees: 'fees',
	CertificateLink: 'certificateLink',
	Logs: 'logs',
	Memberships: 'memberships',
	Points: 'point',
	Senmoni: "senmoni",
	Credits: "credit",
	PdfEvents: "pdfEvents",
	Config: "config",
  BaseForm: "baseForm",
  WorkForm: "workForm",
  AddressForm: "addressForm",
  RecessForm: "recessForm",
  WithdrawalForm: "withdrawalForm",
  TopText: "topText",
}

export const INIT_STATE = {
	[STATE_KEY.LoginForm]: {
		loginId:'',
		password:''
	},
	[STATE_KEY.CreditForm]: {
		cardName:'',
		cardNo: '',
		secure: '',
		month: '01',
		year: '2017',
		tel: '',
		email: '',
		email2: ''
	},
  // [STATE_KEY.AddressForm]: {
  //   id: 0,
  //   lastName: "",
  //   firstName: "",
  //   lastNameYomi: "",
  //   firstNameYomi: "",
  //   workPlace: "",
  //   workSection: "",
  //   occupation: "",
  //   year: "1970",
  //   month: "01",
  //   date: "01",
  //   addrType: "",
  //   zip1: "",
  //   zip2: "",
  //   pref: "北海道",
  //   addr1: "",
  //   addr2: "",
  //   tel: "",
  //   fax: "",
  //   mailAddress: "",
  //   mailAddress2: "",
  //   partReal: false,
  //   partSocial: false,
  //   partWeb: false,
  //   partCoord: false,
  //   jsog: "",
  //   jua: "",
  //   participationType: "0",
  //   state: 0,
  // },  
}
export const MAIL_CHECK = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const INPUT_CHECK = {
	loginId: {
		varName: 'loginId',
		re: /^[0-9]{7}$/,
		message: '会員番号は半角英数字7文字で入力してください。',
		require: true
	},
	password: {
		varName: 'password',
		re: /^[0-9A-Z-a-z\._-]{4,}$/,
		message: '半角英数字4文字以上で入力してください。',
		require: true
	},
	newPassword: {
		varName: 'newPassword',
		re: /^[0-9A-Z-a-z\._-]{4,}$/,
		message: '半角英数字4文字以上で入力してください。',
		require: true
	},
	checkPassword: {
		varName: 'checkPassword',
		re: /./,
		message: 'パスワードと内容が異なります。',
		require: true
	},
	email: {
		varName: 'email',
    re: MAIL_CHECK,
		message: '半角英数字で正確に入力してください。',
		require: true
	},
	email2: {
		varName: 'email2',
		re: /./,
		message: 'メールアドレスと内容が異なります。',
		require: true
	},
  tel: {
    varName: "tel",
    re: /^0[\d-]{11,12}$/,
    message: "半角数字・半角ハイフンで入力して下さい。（例:03-0001-0002）",
    require: false,
  },
  fax: {
    varName: "fax",
    re: /^0[\d-]{11,12}$/,
    message: "半角数字・半角ハイフンで入力して下さい。（例:03-0001-0002）",
    require: false,
  },
  mobile: {
    varName: "mobile",
    re: /^0(7|8|9)0-\d{4}-\d{4}$/,
    message: "半角数字・半角ハイフンで入力して下さい。（例:090-0001-0002）",
    require: false,
  },
  mailAddress: {
    varName: "mailAddress",
    re: MAIL_CHECK,
    message: "半角英数字で正確に入力して下さい。",
    require: true,
  },
  mailAddress2: {
    varName: "mailAddress2",
    re: /./,
    message: "メールアドレスと内容が異なります。",
    require: true,
  },
  lastName: {
    varName: "lastName",
    re: /./,
    message: "",
    require: true,
  },
  firstName: {
    varName: "firstName",
    re: /./,
    message: "",
    require: true,
  },
  lastNameYomi: {
    varName: "lastNameYomi",
    re: /./,
    message: "",
    require: true,
  },
  firstNameYomi: {
    varName: "firstNameYomi",
    re: /./,
    message: "",
    require: true,
  },
  lastNameEng: {
    varName: "lastNameEng",
    re: /^[A-Z]+$/,
    message: "姓(英語表記)を半角英字大文字で入力して下さい。",
    require: true,
  },
  firstNameEng: {
    varName: "firstNameEng",
    re: /^[A-Z]+$/,
    message: "名(英語表記)を半角英字大文字で入力して下さい。",
    require: true,
  },
  middleNameEng: {
    varName: "middleNameEng",
    re: /^[A-Z .-]+$/,
    message: "ミドルネーム(英語表記)を半角英字大文字(空白可)で入力して下さい。",
    require: false,
  },
  telWithdrawal: {
    varName: "telWithdrawal",
    re: /^0[\d-]{11,12}$/,
    message: "半角数字・半角ハイフンで入力して下さい。（例:03-0001-0002）",
    require: true,
  },
}
export const RESERVATION_DONE_MSG = "新規受付は終了しました。以降は学会事務局へメールで直接残席等についてはお問い合わせください。"

interface Lecture {
	period: string,
	lecturer: string,
	subject: string,
	area: string,
}

interface Event {
	id: string,
	eventName: string,
	dateDesc: string,
	date: string,
	amount: string,
	chairman: string,
	addr: string,
	tel: string,
	lectures: Lecture[]
}

export const DEMO_IDS = [9920133, 10087, 9910067, 9999999, 123456]

export const MEMBER_PHOTO_URL = `${CDN_URL}/member/photo/`
export const MAGAZINE_URL = `${CDN_URL}/magazine/index.html`

export const IDOU_KUBUNS = [ 
	"入会中",
	"退会予定",
	"休会",
	"退会",
	"物故",
	"資格喪失",
 ]

 export const PREFECTURES = [
  "",
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
]

export const INPUT_INFO = {
  lastName: {
    name: "姓※",
  },
  firstName: {
    name: "名※",
  },
  lastNameYomi: {
    name: "姓(よみ)※",
  },
  firstNameYomi: {
    name: "名(よみ)※",
  },
  lastNameEng: {
    name: "LastName",
  },
  firstNameEng: {
    name: "FirstName",
  },
  middleNameEng: {
    name: "MiddleName",
  },
  workPlace: {
    name: "勤務先名",
    size: 6,
  },
  workSection: {
    name: "部署",
    size: 6,
  },
  occupation: {
    name: "職種・役職",
    size: 6,
  },
  wAddr: {
    name: "住所",
    size: 6,
  },
  addr1: {
    name: "市区町村番地番号",
    size: 6,
  },
  addr2: {
    name: "建物名など",
    size: 6,
  },
  tel: {
    name: "電話番号",
    size: 6,
    minLength: 12,
    maxLength: 13,
    inputmode: "numeric",
  },
  telWithdrawal: {
    name: "電話番号※",
    size: 6,
    minLength: 12,
    maxLength: 13,
    inputmode: "numeric",
    desc: "お問合せ申し上げる場合がございますので、必ず日中連絡が取りやすい電話番号をご入力下さい。",
  },
  fax: {
    name: "FAX番号",
    size: 6,
    minLength: 12,
    maxLength: 13,
    inputmode: "numeric",
  },
  mobile: {
    name: "携帯番号",
    size: 6,
    minLength: 13,
    maxLength: 13,
    inputmode: "numeric",
  },
  wTel: {
    name: "電話番号",
    size: 6,
    minLength: 12,
    maxLength: 13,
    inputmode: "numeric",
  },
  wFax: {
    name: "FAX番号",
    size: 6,
    minLength: 12,
    maxLength: 13,
    inputmode: "numeric",
  },
  jsog: {
    name: "日本産科婦人科学会",
    size: 6,
    minLength: 8,
    maxLength: 8,
    inputmode: "numeric",
  },
  jua: {
    name: "日本泌尿器科学会",
    size: 6,
    minLength: 5,
    maxLength: 6,
    inputmode: "numeric",
  },
  mailAddress: {
    name: "連絡用PCメールアドレス※",
    size: 6,
  },
  mailAddress2: {
    name: "連絡用PCメールアドレス確認用※",
    size: 6,
  },
  partReal: {
    name: "現地開催",
    desc: "2022年11月3日・4日　パシフィコ横浜会議センター",
  },
  // partSocial: {
  //   name: "懇親会",
  //   desc: "2021年11月11日",
  // },
  partWeb: {
    name: "オンデマンド配信",
    desc: "2022年11月26日-12月9日",
  },
  addrSelect: {
    name: "勤務先住所を利用する",
    desc: [
      "郵便物等の送付先住所を選択してください。",
    ],
  },
  cardName: {
    name: "カードご名義※",
    size: 6,
  },
  cardNo: {
    name: "カード番号※",
    size: 6,
    minLength: 14,
    maxLength: 16,
    inputmode: "numeric",
  },
  secure: {
    name: "セキュリティコード※",
    size: 6,
    minLength: 3,
    maxLength: 4,
    inputmode: "numeric",
  },
  bikou: {
    name: "備考",
    size: 6,
    desc: "変更事由・伝達事項等",
  },
  reason: {
    name: "理由",
    size: 6,
  },
  rfReason: {
    name: "休会理由※",
    size: 6,
  },
  contactInfo: {
    name: "休会中連絡先※",
    size: 6,
    desc: "ご本人様メールアドレス、ご家族のお電話番号など、休会中の連絡先をご記入ください。",
  },
  rfCountry: {
    name: "国名※",
    size: 6,
    desc: "例）Japan",
  },
  rfZip: {
    name: "郵便番号※",
    size: 6,
    desc: "例）100-0014",
  },
  rfAddr1: {
    name: "住所1※",
    size: 6,
    desc: "例）Nagatacho, Chiyoda-ku, Tokyo",
  },
  rfAddr2: {
    name: "住所2※",
    size: 6,
    desc: "例）AiosNagatacho 503, 2-17-17",
  },
  rfSection: {
    name: "施設名・所属",
    size: 6,
    desc: "例）Japan Society for Reproductive Medicine",
  },
}
/*
  cardName: string
  cardNo: string
*/
export const BIRTH_YEAR_START = 100
export const BIRTH_YEAR_END = 18

export const MODIFY_MSG = "※変更が必要な情報のみご入力ください。現在の登録情報は表示されていません。"
